// Минимальная реализация для обратной совместимости с мессенджером
// TODO: Заменить на WebSocket для real-time обновлений

export type UpdatesChanges = {
  news?: boolean;
  projects?: boolean;
  vacancies?: boolean;
  settings?: boolean;
  messages?: boolean;
};

export type UpdatesEventDetail = {
  snapshot: any;
  changes: UpdatesChanges;
};

export const UPDATES_EVENT_NAME = 'lisad-updates';

// Пустая функция - polling отключён, используется SWR для основных данных
export function startUpdatesWatcher(_pollMs: number = 15000): void {
  // Polling отключён — SWR автоматически ревалидирует данные
}

// Ручной триггер для push-уведомлений
export function emitUpdates(changes: UpdatesChanges): void {
  if (typeof window === 'undefined') return;
  const hasChange = Boolean(changes.news || changes.projects || changes.vacancies || changes.settings || changes.messages);
  if (!hasChange) return;
  const snapshot = { server_time: new Date().toISOString() };
  window.dispatchEvent(new CustomEvent(UPDATES_EVENT_NAME, { detail: { snapshot, changes } }));
}

// Подписка на события (для мессенджера)
export function subscribeUpdates(handler: (detail: UpdatesEventDetail) => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const onEvent = (e: Event) => {
    const detail = (e as CustomEvent).detail as UpdatesEventDetail | undefined;
    if (!detail) return;
    handler(detail);
  };
  window.addEventListener(UPDATES_EVENT_NAME, onEvent as EventListener);
  return () => window.removeEventListener(UPDATES_EVENT_NAME, onEvent as EventListener);
}
